/**
 * React implementation of component builder class for building components based on the configuration.
 */
export class ComponentBuilder {
    constructor(config) {
        this.config = config;
        this.components = new Map([...config.components]);
    }
    /**
     * Creates a new instance of component factory
     * @returns {ComponentFactory} Component factory implementation
     */
    getComponentFactory() {
        return (componentName) => {
            const component = this.components.get(componentName);
            if (!component)
                return null;
            return component;
        };
    }
}
